module.exports = __webpack_public_path__ + "assets/img/D-1.0886548b.jpg";